<template>
  <div class="flex flex-col">
    <slot name='default' />
   <div v-if='enableHorizontal' class="my-1 flex w-full justify-start flex-row">
      <pbc-button @click='alignMiddle' class="format-button">
        <format-horizontal-align-center :size='12' />Middle
      </pbc-button>
      <pbc-button @click='alignLeft' class="format-button">
        <format-horizontal-align-left :size='12' />Left
      </pbc-button>
      <pbc-button @click='alignRight' class="format-button">
        <format-horizontal-align-right :size='12' />Right
      </pbc-button>
      <h1 class="heading">Horizontal</h1>
    </div>

    <div v-if='enableVertical' class="my-1 flex w-full justify-start flex-row">
      <pbc-button @click='alignCenter' class="format-button"><format-vertical-align-center :size='12' />Center</pbc-button>
      <pbc-button @click='alignTop' class="format-button"><format-vertical-align-top :size='12' />Top</pbc-button>
      <pbc-button @click='alignBottom' class="format-button"><format-vertical-align-bottom :size='12' />Bottom</pbc-button>
      <h1 class="heading">Vertical</h1>
    </div>

 
    <!--
    <div class="my-1 flex w-full justify-start flex-row">

      <h1 class="heading">Scale</h1>
      <pbc-button @click='scaleContain'
                 class="format-button">
        <fit-to-page :size='12' />Contain
      </pbc-button>
      <pbc-button @click='scaleCover'
                  class="format-button">
        <fit-to-page-outline :size='12' />Cover
      </pbc-button>
      <pbc-button @click='scaleOriginal'
                  class="format-button">
        <undo-variant :size='12' />Original
      </pbc-button>

    </div>
    -->
  </div>
</template>
<script>
import FormatVerticalAlignCenter from '@icons/FormatVerticalAlignCenter.vue';
import FormatVerticalAlignTop from '@icons/FormatVerticalAlignTop.vue';
import FormatVerticalAlignBottom from '@icons/FormatVerticalAlignBottom.vue';
import FitToPage from '@icons/FitToPage.vue';
import FitToPageOutline from '@icons/FitToPageOutline.vue';
import FormatHorizontalAlignLeft from '@icons/FormatHorizontalAlignLeft.vue';
import FormatHorizontalAlignRight from '@icons/FormatHorizontalAlignRight.vue';
import FormatHorizontalAlignCenter from '@icons/FormatHorizontalAlignCenter.vue';
import UndoVariant from '@icons/UndoVariant.vue';
export default {
  props: {
    transform: {
      type: Object,
      required: true
    },
    holderData: {
      type: Object,
      required: true
    },
    renderTools: {
      type: Object,
      required: true
    },
    enableHorizontal: {
      type: Boolean,
      default: true
    },
    enableVertical: {
      type: Boolean,
      default: true
    }
  },
  components:{
    FormatVerticalAlignBottom,
    FormatVerticalAlignTop,
    FormatVerticalAlignCenter,
    FormatHorizontalAlignCenter,
    FormatHorizontalAlignRight,
    FormatHorizontalAlignLeft,
    //FitToPage,
    //FitToPageOutline,
    //UndoVariant
  },
  methods:{
    alignBottom() {
      const {holder,updateContainerBounds} = this.holderData[this.transform.id];
      holder.alignBottom();
      this.renderTools.addToUpdateBatch(holder);
      updateContainerBounds();
      this.$ana.track({
        eventCategory: 'ui',
        eventAction: 'scalingAlignment',
        extra:{type:'alignBottom'}
      });
      this.$emit("center");
      this.$emit('align-vertical', 'bottom');
    },
    alignTop() {
      const {holder,updateContainerBounds} = this.holderData[this.transform.id];
      holder.alignTop();
      this.renderTools.addToUpdateBatch(holder);
      updateContainerBounds();
      this.$ana.track({
        eventCategory: 'ui',
        eventAction: 'scalingAlignment',
        extra:{type:'alignTop'}
      });
      this.$emit("center");
      this.$emit('align-vertical', 'top');
    },
    alignCenter() {
      const {holder,updateContainerBounds} = this.holderData[this.transform.id];
      holder.alignCenter();
      this.renderTools.addToUpdateBatch(holder);
      updateContainerBounds();
      this.$ana.track({
        eventCategory: 'ui',
        eventAction: 'scalingAlignment',
        extra:{type:'alignCenter'}
      });
      this.$emit("center");
      this.$emit('align-vertical', 'center');
    },
    scaleCover() {
      const {holder,updateContainerBounds} = this.holderData[this.transform.id];
      holder.scaleCover();
      this.renderTools.addToUpdateBatch(holder);
      updateContainerBounds();
      this.$ana.track({
        eventCategory: 'ui',
        eventAction: 'scalingAlignment',
        extra:{type:'scaleCover'}
      });
      this.$emit("center");
    },
    scaleContain() {
      const {holder,updateContainerBounds} = this.holderData[this.transform.id];
      holder.scaleContain();
      this.renderTools.addToUpdateBatch(holder);
      updateContainerBounds();
      this.$ana.track({
        eventCategory: 'ui',
        eventAction: 'scalingAlignment',
        extra:{type:'scaleContain'}
      });
      this.$emit("center");
    },
    scaleOriginal() {
      const {holder,updateContainerBounds} = this.holderData[this.transform.id];
      holder.scaleOriginal();
      this.renderTools.addToUpdateBatch(holder);
      updateContainerBounds();
      this.$ana.track({
        eventCategory: 'ui',
        eventAction: 'scalingAlignment',
        extra:{type:'scaleContain'}
      });
      this.$emit("center");
    },

    alignLeft() {
      const {holder,updateContainerBounds} = this.holderData[this.transform.id];
      holder.alignLeft();
      this.renderTools.addToUpdateBatch(holder);
      updateContainerBounds();
      this.$ana.track({
        eventCategory: 'ui',
        eventAction: 'scalingAlignment',
        extra:{type:'alignLeft'}
      });
      this.$emit("center");
      this.$emit('align-horizontal', 'left');

    },
    alignRight() {
      const {holder,updateContainerBounds} = this.holderData[this.transform.id];
      holder.alignRight();
      this.renderTools.addToUpdateBatch(holder);
      updateContainerBounds();
      this.$ana.track({
        eventCategory: 'ui',
        eventAction: 'scalingAlignment',
        extra:{type:'alignRight'}
      });
      this.$emit("center");
      this.$emit('align-horizontal', 'right');
    },
    alignMiddle() {
      const {holder,updateContainerBounds} = this.holderData[this.transform.id];
      holder.alignMiddle();
      this.renderTools.addToUpdateBatch(holder);
      updateContainerBounds();
      this.$ana.track({
        eventCategory: 'ui',
        eventAction: 'scalingAlignment',
        extra:{type:'alignMiddle'}
      });
      this.$emit("center");
      this.$emit('align-horizontal', 'center');
    }
  }
}
</script>
<style scoped>
.heading {
@apply text-sm text-gray-400 mx-2 font-semibold tracking-wide text-left;
}
.format-button {
  @apply bg-blue-600 text-xs p-1 mx-1 text-black font-thin;
}
</style>
